import { themr } from '@friendsofreactjs/react-css-themr';

import InvoiceDetails from './InvoiceDetails';

export default themr('InvoiceDetails')(InvoiceDetails);
